import { connect } from 'react-redux';

import { LinksSection } from './LinksSection';

import { isMapView } from '../../domain/state/map/selectors';
import { modifierStylesSelector } from '../../domain/state/modifier/selectors';

import type { IStateProps } from './types';

const mapStateToProps = (state) => ({
  mapExpanded: isMapView(state),
  modifierStyles: modifierStylesSelector(state),
});

export default connect<IStateProps>(mapStateToProps)(LinksSection);
